jQuery(document).ready( function() {
  jQuery(window).scroll(function() {
    if(jQuery('.essential_countdown_annoucement_bar_wrapper').length){
         var scroll = jQuery(window).scrollTop();
          if ( scroll > 0 ) {
            jQuery('.essential_countdown_annoucement_bar_wrapper').css('position','fixed');
          }
          else {
            jQuery('.essential_countdown_annoucement_bar_wrapper').css('position','relative');
          }    
        }
  });
});
(function($) {
  $(document).on('click', 'a[href*="#"]:not(".pt-nav-toggle")', function(e) {
      console.log('click');
	    var jump = $(this).attr('href').replace('#', '');
	    var new_position = $('a[name*="' + jump + '"]').offset();
      	new_position = (new_position.top - 100)
	    $('html, body').stop().animate({ scrollTop: new_position }, 500);
	    e.preventDefault();
  });
  function quickCart() {
    if (window.location.search.indexOf("quickcart") != -1) {
      $('#cart-modal').modal();
    }
  };

  function itemQuickCartRemove() {
    $('#cart-modal a.item-remove').on('click', function(e) {
      e.preventDefault();
      var itemID = $(this).attr('data-id');
      console.log(itemID);

      Shopify.removeItem(itemID);


      window.location.href = window.location.href;
    });
  }

  function objectifyForm(formArray) {
    var returnArray = {};
    for (var i = 0; i < formArray.length; i++){
      returnArray[formArray[i]['name']] = formArray[i]['value'];
    }
    return returnArray;
  }

  var addToCart = function() {
    $("#add-to-cart").on('click', function(e){
      e.preventDefault();

      var dataProductForm = $('.product_form').serializeArray();
      dataProductForm = objectifyForm(dataProductForm);
      console.log(dataProductForm);

      Shopify.addItem(dataProductForm.id, dataProductForm.quantity, function(data){
        // Do Something here once the product is added
        hj('tagRecording',['add-to-cart']);
        window.location.search = 'quickcart=true';
      });

    });
  }

  var newsletterSignup = function() {

    $('form[name="mc-embedded-subscribe-form"]').each(function() {
      $(this).on("submit", function (e) {
        e.preventDefault();
        var $el = $(this);

        // place button in working state
        $btn = $el.find('.footer-form-submit');   
        $btn.addClass('isBusy');
        $btn.attr('value','busy...');

        $.ajax({
          type: $(this).attr('method'),
          url: $(this).attr('action'),
          data: $(this).serialize(),
          cache: false,
          dataType: 'jsonp',
          jsonp: 'c',
          contentType: "application/json; charset=utf-8",
      		complete: function(data) {
              console.log('success: ',data);
                if (data.statusText != "success") {
                  // maybe we make some error stuff in the future
                } else {
                  $btn.removeClass('isBusy').addClass('success');
                  $btn.attr('value','success!');
                  $el.find('input[name="EMAIL"]').val('');

                  window.setTimeout(function() {
                  	$btn.attr('value','SUMBIT');
                    $el.find('input[name="EMAIL"]').focus();
                  }, 2000);
                }
            }
          });
          e.preventDefault();
      });


    });
    // console.log($contact_form);
  }

  var searchBarReveal = function() {

    $("#header-search-submit").click(function(){
      $("#desktop-nav-search").submit();
    });
  }

  var scrollToTop = function() {
  	// browser window scroll (in pixels) after which the "back to top" link is shown
	var offset = 300,
		//browser window scroll (in pixels) after which the "back to top" link opacity is reduced
		offset_opacity = 1200,
		//duration of the top scrolling animation (in ms)
		scroll_top_duration = 700,
		//grab the "back to top" link
		$back_to_top = $('.cd-top');

	//hide or show the "back to top" link
	$(window).scroll(function(){
		( $(this).scrollTop() > offset ) ? $back_to_top.addClass('cd-is-visible') : $back_to_top.removeClass('cd-is-visible cd-fade-out');
		if( $(this).scrollTop() > offset_opacity ) {
			$back_to_top.addClass('cd-fade-out');
		}
	});

	//smooth scroll to top
	$back_to_top.on('click', function(event){
		event.preventDefault();
		$('body,html').animate({
			scrollTop: 0 ,
		 	}, scroll_top_duration
		);
	});
  }

  var productPageQuantityButtons = function() {
  	var currentQTY = $("#quantity").val();

    $("#qty-up").click(function(e){
        e.preventDefault();
        currentQTY++;
        $("#quantity").val(currentQTY);
    });

    $("#qty-down").click(function(e){
        if(currentQTY > 1){
            e.preventDefault();
            currentQTY--;
            $("#quantity").val(currentQTY);
        }
    });
  }

  var setShopifyQueryParams = function() {
  	Shopify.queryParams = {};
    if (location.search.length) {
      for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
        aKeyValue = aCouples[i].split('=');
        if (aKeyValue.length > 1) {
          Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        }
      }
    }
  }

  var showQuickShop = function() {
  	if ($(window).width() >= 959) {
    	$('.thumbnail').hover(function(){ $('.quick_shop', this).css('visibility','visible'); }, function(){ $('.quick_shop', this).css('visibility','hidden'); })
    }
  }

  var activateEqualHeights = function(elements) {

    $(elements).each(function(i,v) {
      $(v).equalHeights();
    });
  }

  var productPageTabs = function() {
  	var tabs = $('ul.tabs');
    tabs.each(function(i) {
      var tab = $(this).find('> li > a');
      tab.click(function(e) {
        var contentLocation = $(this).attr('href');
        if(contentLocation.charAt(0)=="#") {
          e.preventDefault();
          tab.removeClass('active');
          $(this).addClass('active');
          $(this).parents('ul.tabs').next().find(contentLocation).show().css({'display': 'block'}).addClass('active').siblings().hide().removeClass('active');
        }
      });
    });
  }

  var showSizingTables = function() {
    $('#lcsize_guide').on('click', function(){
      $('.exp_guide').toggleClass('show');
    });
  }

  var clickHeader = function() {
    $('.spr-header-top .spr-summary-actions-newreview').removeAttr('onclick');

    $('.spr-header-top .spr-summary-actions-newreview').attr('href', '#shopify-product-reviews');
  }

  var productShippingReturns = function() {
    $('<li><a href="#tab4" class="">Shipping &amp; Returns</a></li>').appendTo('.tabs');
    $('<li id="tab4" style="display:none" class="active"><p>Shipping:</p><ul><li>In the contiguous U.S., orders that qualify for ground shipping will receive FREE shipping. </li><li>Orders ship within 7-10, and any orders that may fall outside that window will be notified with specific details.</li></ul><p>For full shipping details, please see our <a href="https://lightingconnection.com/pages/shipping-policy">Shipping Policy page</a>.</p><p>Returns:</p><ul><li>We stand behind our products and 100% guarantee your satisfaction with every order. If you do choose to return it, you may send it back uninstalled and in the original packaging within <b>30 days</b> from receipt of purchase for a full refund (less shipping) upon inspection.</li></ul><p>To see our full Returns and Exchanges policy, and see please continue to read <a href="https://lightingconnection.com/pages/return-policy">here</a>.</p></li>').appendTo('.tabs-content');
  }

  var addsSizingCalc = function() {
    $('.product-form-full .form-group.select .selector-wrapper:first-child label').html('CHOOSE YOUR SIZE <a class="size_help" id="szcopen" href="">Try Our Sizing Calculator</a> ');

  }

  var putProductReviewsInHeader = function() {
    setTimeout(function() {
      $(".spr-summary .spr-starrating").clone().insertAfter(".panel-product-main .was_price");
      var caption = $('.spr-container .spr-summary-caption').clone();
      caption.text(caption.text().replace('Based on ','').trim());
      caption.insertAfter('.panel-product-main .spr-starrating');
    }, 3000);

    $(document).on('click', '.spr-summary:eq(0)', function (){
      $('html, body').animate({
       scrollTop: $("#shopify-product-reviews").offset().top -100
      }, 0);
    });
  }

  function checkContainer () {
    if($('.spr-review-header-byline').is(':visible')){
      //console.log('yes');

      for (var g=0; g < $('.spr-review').length; g++){
        //console.log(g);
        $('.spr-review:eq('+g+') .spr-review-header-byline').prependTo('.spr-review:eq('+g+') .spr-review-header');

        var nm = $('.spr-review:eq('+g+') .spr-review-header-byline strong:eq(0)').text();
        //console.log(nm);
        $('.spr-review:eq('+g+') .spr-review-header-byline').text(nm);

        $('.spr-review-header-title:eq('+g+')').insertAfter('.spr-review-header-byline:eq('+g+')');
      }

      $('.spr-reviews').prependTo('.spr-content');
      $('.spr-form-title').text('Leave A Review');

    } else {
      //console.log('no');
      setTimeout(checkContainer, 50);
    }
  }

  var updateSubtotalInput = function() {
  	$("#cart_form input[type='number']").change(function() {$("#cart_form").submit(); });
  }

  var updateSubtotalButton = function() {
    $('.update_subtotal').click(function() { $("#cart_form").submit(); return false; });
  }

  var activateAffixNavDesktop = function() {
  	var menuTop = $('header').offset().top;
  	$('#news-container').affix({
      offset: {top: 500}
    });
  }

  var activateAffix = function() {
    if ($('#main-menu').length > 0) {
      var menuTop = $('#main-menu').offset().top;

      $('#main-menu').affix({
        offset: {
          top: menuTop,
          bottom: $('.stopper').outerHeight(true)
        }
      });
    }
  }


  var collapseSidebarNavs = function() {
  	$(document).ready(function(){

      $('#main-menu li').each(function(i,v) {
        $(this).find('.accordion-button').click(function(event) {
          event.preventDefault();
              // accordion-content
          $(this).siblings('.accordion-content').toggle();
          
          if ($(this).children('span').html() == '-') {
          	$(this).children('span').html('+');
          }
          else {
            $(this).children('span').html('-');
          }

        });
      });
    });
  }
  
  /**
   * detect IE
   * returns version of IE or false, if browser is not Internet Explorer
   */
  function detectIE() {
      var ua = window.navigator.userAgent;

      var msie = ua.indexOf('MSIE ');
      if (msie > 0) {
          // IE 10 or older => return version number
          return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
      }

      var trident = ua.indexOf('Trident/');
      if (trident > 0) {
          // IE 11 => return version number
          var rv = ua.indexOf('rv:');
          return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
      }

      var edge = ua.indexOf('Edge/');
      if (edge > 0) {
         // Edge (IE 12+) => return version number
         return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
      }
    
      // other browser
      return false;
  }
  

  var activateSlider = function() {
  	$('#product_slider').flexslider({
      animation: "slide",
      controlNav: true,
      animation: "slide",
      slideshow: false,
      prevText: "",
      nextText: "",
      manualControls: "",
      directionNav: true
      // slideshowSpeed: 10*1000
    });
  }
  $(function() {
    /**~ Activate Scroll to Top ~**/
    scrollToTop();

    quickCart();

    /**~ Add to cart popup ~**/
    addToCart();

    itemQuickCartRemove();

    /**~ Newsletter Signup ~**/
    newsletterSignup();

    /**~ IMPORTANT set properties of Shopify.queryParams ~**/
    setShopifyQueryParams();

    /**~ Collapse sidebar subnavs ~**/
    collapseSidebarNavs();

    /**~ Show quickshop buttons on collection pages ~**/
    showQuickShop();

    /**~ Product Page Quantity Buttons ~**/
    productPageQuantityButtons();

    /**~ Header Search Bar Reveal Code ~**/
    searchBarReveal();

    /**~ Product Shipping Returns ~**/
    productShippingReturns();

    if (detectIE()) {
      $('.quick_shop').css('display', 'none');
    }


    if (window.location.pathname === "/cart") {

      /**~ Update Subtotal ~**/
      updateSubtotalButton();
      updateSubtotalInput();
    }

    $('.container').imagesLoaded( function() {

      /**~ Activate Affix ~**/
      activateAffix();
      var elements = [
        '.hold-well'
      ];
      /**~ activate equal heights ~**/
      activateEqualHeights(elements);

      if ($(window).width() > 764) {
        /**~ activate equal heights ~**/
        var elements = [
          '.thumbnail'
        ];
        activateEqualHeights(elements);

        activateAffixNavDesktop();
      }
    });

  });

  $(window).load(function() {

    /**~ Activate Cart page slider ~**/
    activateSlider();

    /**~ Activate Tabs ~**/
    productPageTabs();

    /**~ Activate show/hide sizing ~**/
    showSizingTables();

    /**~ Checking container and putting it behind reviews already created ~**/
    checkContainer();

    /**~ throw product reviews in header because its a 3rd party plugin ~**/
    putProductReviewsInHeader();

    /**~ Adds Sizing Calculator ~**/
    addsSizingCalc();


    $(window).on("resize", function(){
       /**~ Activate Affix ~**/
      activateAffix();
    });

  });

  $(window).load(function() {

    $('.single-option-selector').addClass('form-control');

  });

  $(function() {
    if ($('#collection-description').outerHeight() > 320) {

      var centerAppend = '<div class="text-center col-md-12"><a class="read-more">[Read More]</a></div>';

      $('#collection-description').append(centerAppend);

      $('#collection-description').find('.description-inner').css({'max-height': '200px', 'overflow': 'hidden'});
    }

    $('#collection-description .read-more').on('click', function() {
      $('#collection-description').find('.description-inner').css({'max-height': 'unset', 'overflow': 'hidden'});
      $('#collection-description > div.text-center').hide();
      $(this).hide();
    });

  });

active = 0;
old = 0;
total = 0;
$(document).ready( function() {
  $(".mobile-sticky").each(function() {
      $(this).addClass("stickit");
    	total++;
    })
   	$('.mobile-sticky').eq(0).css('z-index', '8');
   	$('.mobile-sticky').css('left', $(window).width() + 'px');
   	$('.mobile-sticky').eq(0).css('left', '0px');
   	$('.mobile-sticky').css('transition-property', 'left');
   	$('.mobile-sticky').css('transition-duration', '2s');
  	setInterval(swapsticky, 7000);
 });
  function swapsticky() {
    console.log('total ' + total);
    console.log('old ' + old);
    console.log('active ' + active);
    $('.mobile-sticky').not(':eq(' + active + ')',':eq(' + old + ')').css('z-index', '8');
   	$('.mobile-sticky').not(':eq(' + active + ')',':eq(' + old + ')').css('left', $(window).width() + 'px');
  	$('.mobile-sticky').eq(active).css('z-index', '10');
   	$('.mobile-sticky').eq(active).css('left', '-' + $(window).width() + 'px');
    old = active;
  	active++;
    if (active == total) { active = 0; }
    console.log('new active ' + active);
  	$('.mobile-sticky').eq(active).css('z-index', '10');
  	$('.mobile-sticky').eq(active).css('left', '0px');
  }
 

})(jQuery);

$(function() {

  selectCallback = function(variant, selector) {
    var $product = $('#product-' + selector.product.id);
    var $notify_form = $('#notify-form-' + selector.product.id);
    var items_left_text = "";

    window.pdp = window.pdp || {};

    window.pdp.variant = variant;

    if (variant && variant.featured_image && $product.is(":visible")) {
      var $slider = $('#product_slider', $product);
      var original_image = $(".flex-active-slide img", $product), new_image = variant.featured_image;
      Shopify.Image.switchImage(new_image, original_image[0], function (new_image_src, original_image, element) {
        if ($slider.length) {
          $slider.flexslider($('[data-image-id="' + variant.featured_image.id + '"]').data('index'));
        } else {
          $(element, $product).attr('src', new_image_src);
        }
      });
    }

    if (variant && variant.available == true) {
      if(variant.price < variant.compare_at_price){
        $('.was_price', $product).html(Shopify.formatMoney(variant.compare_at_price, $('form.product_form', $product).data('money-format')))
      } else {
        $('.was_price', $product).text('')
      }

      

      // this runs on variation change if in stock
      $('.modal_price').removeClass('out-of-stock');
      $('.sold_out', $product).removeClass('visible').text('');
      $('.product-price > span', $product).html(Shopify.formatMoney(variant.price, $('form.product_form', $product).data('money-format')));
      $('.back_in_stock-trigger').hide();
      $('.add_to_cart', $product).removeClass('disabled').removeAttr('disabled').val('Add to Cart');
      $notify_form.hide();
      // update QuadPay widget
      $('.modal_price quadpay-widget').attr('amount', variant.price / 100.00);
    } else {
      // out of stock, on variant change
      var message = variant ? "OUT OF STOCK - CALL TO PRE-ORDER" : "OUT OF STOCK - CALL TO PRE-ORDER";
      console.log('variation change:',variant);
      window.product = window.product || {};
      window.product.current_variant = variant;
      window.product.message = message;
      $('.product-price > span', $product).html(Shopify.formatMoney(variant.price, $('form.product_form', $product).data('money-format')));
      $('.modal_price').addClass('out-of-stock');
      $('.was_price', $product).text('');
      $('.items_left', $product).text('');
      $('.quantity', $product).removeAttr('max');
      // this is where it changes from a price to "sold out" messaging
      $('.sold_out', $product).addClass('visible').text(message);
      $('.add_to_cart', $product).addClass('disabled').attr('disabled', 'disabled').val(message);
      // show back in stock button
      $('.back_in_stock-trigger').show();
      // hide QuadPay
      //$('.modal_price quadpay-widget').attr('amount', 0.00);
      // fire GA event
      ga('send', 'event', 'Product', 'Out of Stock', variant.sku);
      $notify_form.fadeIn();
    }

    
  };
});
